import type {
  IClstInstrumentCreateRequest,
  IClstInstrumentCreateResponse,
  IDiscoveredInstrumentsResponse,
  IListDiscoveredInstrumentRequest,
  IListDiscoveredInstrumentResponse,
} from "@pulse-ui/codegen-v2/generated_ts/refdata";
import { api } from "../base";

export type {
  IClstInstrumentCreateRequest,
  IClstInstrumentCreateResponse,
  IDiscoveredInstrumentsResponse,
  IListDiscoveredInstrumentRequest,
  IListDiscoveredInstrumentResponse,
};

const instrumentsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /** Searches discovered instruments that are not yet listed. */
    getDiscoveredInstruments: build.query<
      IDiscoveredInstrumentsResponse,
      { q: string; limit: number }
    >({
      query: ({ q, limit }) => ({
        url: "/api/trading-ops/v1/instruments/discovered",
        params: { q, limit },
      }),
      providesTags: ["RefdataInstruments"],
    }),

    /** Lists a discovered instrument along with any assets it needs. */
    listDiscoveredInstrument: build.mutation<
      IListDiscoveredInstrumentResponse,
      IListDiscoveredInstrumentRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/instruments/list-discovered",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RefdataInstruments", "RefdataAssets"],
    }),

    /** Creates a CLST spot instrument sourcing its feeds from listed symbols. */
    createClstInstrument: build.mutation<
      IClstInstrumentCreateResponse,
      IClstInstrumentCreateRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/instruments/clst-spot",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RefdataInstruments", "RefdataAssets"],
    }),
  }),
});

export const {
  useGetDiscoveredInstrumentsQuery,
  useListDiscoveredInstrumentMutation,
  useCreateClstInstrumentMutation,
} = instrumentsEndpoints;
